import React from 'react';
import './UILegalView.css';
import UIBrand from '../_commons/Brand/UIBrand';
import UIFooter from '../_commons/Footer/UIFooter';

export default class UIAgbView extends React.Component {

    componentDidMount() {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }

    render() {
        const { onBack } = this.props;
        return (
            <div className="UILegalView">

                <header className="legal-header">
                    <div className="legal-header-inner">
                        <UIBrand/>
                        <button className="legal-back-btn" onClick={onBack}>← Zurück</button>
                    </div>
                </header>

                <section className="legal-content">
                    <div className="legal-content-inner">
                        <h1>Kontakt</h1>
asasd
                    </div>
                </section>

                <UIFooter />
            </div>
        );
    }
}

